module.exports = __webpack_public_path__ + "img/music.451281b1.png";